import { defineMessages } from 'react-intl'

const scope = `procurify.components.ItemPrice`

export default defineMessages({
  yearlyFrequency: {
    id: `${scope}.yearly`,
    defaultMessage: 'yearly',
  },
  monthlyFrequency: {
    id: `${scope}.monthly`,
    defaultMessage: 'monthly',
  },
})
